/* eslint-disable no-unused-vars */

export enum BannerType {
  PROFILE_HIDDEN = 'PROFILE_HIDDEN',
  PROFILE_EDIT_MODE = 'PROFILE_EDIT_MODE',
  PROFILE_PREVIEW_MODE = 'PROFILE_PREVIEW_MODE',
  NONE = '',
}

export default BannerType;
